<template>
    <transition name="fade">
        <div v-show="appState === 'login'" class="login" v-bind:class="form_class" :data-state="form_state" :data-processing="processing">
            <div class="login__wrap">

                <div class="eh eh--login">
                    <div class="eh__content c c--tiny--pad pad--h r r--halign-center v--15">
                        <div class="eh__meta type--pre-header type--color--sp-green">Welcome to</div>
                        <h1 class="eh__title type--h1 change" aria-label="SpinePal">
                            <Icon name="sp/spinepal-logo-full" />
                        </h1>
                    </div>
                </div>

                <div class="login__row">
                    <div class="login__form c c--tiny--pad pad--h" style="max-width: 300px;">
                        <div class="login__welcome">
                            <h2 class="notice__message type--p" v-html="current_notice"></h2>
                        </div>
                        <div class="login__form__row r">
                            <div class="notice">
                                <div class="notice__container">
                                    <div class="notice__message type--align-center"></div>
                                </div>
                            </div>
                            <form name="loginform" id="loginform" class="form" :action="action" method="post">
                                <div class="login__form__body">
                                    <ul class="form__body__fields r v--15">
                                        <li class="field validate--empty r v--10">
                                            <label for="user_login" class="">User Name</label>
                                            <input v-model="username" name="log" id="user_login" type="text"
                                                autocomplete="username" />
                                            <span class="message"></span>
                                        </li>
                                        <li class="field validate--empty r v--10">
                                            <label for="user_pass" class="">Password</label>
                                            <span class="r r--row-always">
                                                <input v-model="password" name="pwd" id="user_pass"
                                                    :type="password_input_type" autocomplete="current-password" />
                                                <a href="#" class="svg show-password"
                                                    :data-state="password_showing_state" aria-label="Show Password"
                                                    @click="toggle_show_password">
                                                    <svg width="15" height="15" viewBox="0 0 15 15"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink">
                                                        <g stroke="#000" stroke-width="1.4" fill="none"
                                                            fill-rule="evenodd" stroke-linecap="round"
                                                            stroke-linejoin="round">
                                                            <path
                                                                d="M11.55 11.55a6.866 6.866 0 0 1-4.05 1.405C2.727 12.955 0 7.5 0 7.5a12.58 12.58 0 0 1 3.45-4.05m2.618-1.24c.47-.11.95-.166 1.432-.165C12.273 2.045 15 7.5 15 7.5a12.614 12.614 0 0 1-1.473 2.175m-4.582-.73a2.045 2.045 0 1 1-2.89-2.89" />
                                                            <path class="cross" d="m0 0 15 15" />
                                                        </g>
                                                    </svg>
                                                </a>
                                            </span>
                                            <span class="message"></span>
                                        </li>
                                        <li v-if="siloData.messages.pw_assistance" class="field login__form__note">
                                            <span><a href="#" class="type--h6--default"
                                                    style="color:var(--color-sp-mint);" @click="open_modal_help">Need
                                                    Help Logging-In?</a></span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="login__form__footer">
                                    <div class="login__form__footer__wrapper r r--halign-center r--valign-center">
                                        <input class="btn btn--solid btn--purple" name="wp-submit" id="wp-submit"
                                            type="submit" aria-label="Log In" value="Log In" @click.prevent="login" />
                                        <div v-if="current_explaination" class="explaination">
                                            <div v-html="current_explaination"></div>
                                        </div>
                                        <input type="hidden" name="redirect_to"
                                            :value="this.siloData.urls.home + '?logged-in=true'">
                                        <input type="hidden" name="testcookie" value="1" />
                                        <input type="hidden" name="login" value="true" />
                                        <input v-if="nonce" type="hidden" id="security" name="security"
                                            :value="nonce" />
                                        <input type="hidden" name="_wp_http_referer" value="/login" />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="login__version r r--justify-center type--align-center pad--h">
                            <span style="color:var(--color-sp-border-dark)">v.{{ this.siloData.user.app.version }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Icon from "@c/Icon.vue";
const axios = require('axios');
export default {
    components: {
        Icon,
    },
    data() {
        return {
            username: '',
            password: '',
            current_notice: "Please log in to continue.",
            current_explaination: "",
            notice: {
                default: "Please log in to continue.",
                success: `<div style='text-align:center'>Login successful!</div>`,
                error: "User Name or Password not recognized.",
                loading: `<div style='text-align:center'>Logging in...</div>`,
            },
            password_input_type: 'password',
            password_showing_state: 'inactive',
            form_class: '',
            form_state: '',
            processing: false,
        }
    },
    props: {
        appState: String,
        siloData: Object,
        nonce: String,
        referer: String,
        action: String,
        version: String,
    },
    watch: {
        appState() {
            if (this.appState === 'login') {
                this.reset_form();
            }
        }
    },
    mounted() {
        this.show_form();
    },
    methods: {
        reset_form() {
            document.documentElement.classList.add('loading');
            this.processing = false;
            this.form_class = "";
            this.form_state = "";
            this.current_notice = this.notice.default;
            this.current_explaination = "";
        },
        show_form() {
            setTimeout(() => {
                document.documentElement.classList.remove('loading');
                document.documentElement.classList.add('loaded');
            }, 300);
        },
        // Check the current login status
        check_login_status() {
            // Maybe do this later
        },
        open_modal_help() {
            modal.set(
                {
                    button: false,
                    message: this.siloData.messages.pw_assistance,
                    additional_classes: 'notice-centered'
                }
            );
        },
        open_modal_about() {
            modal.set(
                {
                    button: false,
                    message: this.siloData.messages.login_about,
                    additional_classes: 'notice-centered'
                }
            );
        },
        open_modal_terms() {
            modal.set(
                {
                    button: false,
                    hide_close: true,
                    message: `.${this.$refs.tos.classList[0]}`, // allows us to grab the element from the ref
                    message_is_element: true,
                    additional_classes: 'notice-centered'
                }
            );
        },
        toggle_show_password() {
            if (this.password_input_type === "password") {
                this.password_input_type = "text";
                this.password_showing_state = "active";
            } else {
                this.password_input_type = "password"
                this.password_showing_state = "inactive";
            }
        },
        fields_are_valid() {
            return this.validate_empty() ? true : false;
        },
        validate_empty() {

            let required_fields = document.querySelectorAll('.field.validate--empty');
            let required_fields_filled_in = 0;

            required_fields.forEach((field) => {

                let message = field.querySelector('.message');
                let input = field.querySelector('input');
                let label = field.querySelector('label');

                if (field.querySelector('input').value.length > 0) {
                    required_fields_filled_in += 1;

                } else {
                    field.classList.add('required--attention');
                    message.innerText = 'Please enter a valid ' + label.innerText;

                    input.addEventListener('keyup', () => {
                        field.classList.remove('required--attention');
                        message.innerText = "";
                    }, {
                        once: true
                    })
                }
            });

            // Return true if all required fields are filled in
            return required_fields_filled_in === required_fields.length ? true : false;
        },
        async login() {
            if (!this.fields_are_valid()) { return; }

            this.form_class = "disabled";
            this.form_state = "";
            this.current_notice = this.notice.loading;
            this.processing = true;

            //setTimeout(() => {
            try {
                const baseUrl = window.location.origin + '/wp-json';
                const res = await this.$api.post(`${baseUrl}/jwt-auth/v1/token`, {
                    username: this.username,
                    password: this.password
                });

                localStorage.setItem('access_token', res.data.token);
                localStorage.setItem('refresh_token', res.data.refresh_token);
                localStorage.setItem('user_id', res.data.user_id);
                localStorage.setItem('user', JSON.stringify(res.data));

                // request WordPress cookie
                await this.$api.post(`${baseUrl}/custom/v1/login-cookie`, {}, {
                    headers: { Authorization: `Bearer ${res.data.token}` },
                    withCredentials: true
                });

                console.log(res.data);

                // 1. wait to get the return data from log in
                // 2. tell the app manager to pull a new set of data
                this.$emit('updateSiloOnLogin');

                // 3. wait until we have that then update the state and set all the cookies
                console.log(res.data.user_id);

                // 4. Update users login stats
                axios(this.siloData.urls.updateloginstats).then((result) => {
                    console.log('updated login stats:', result.data);
                });

                this.finish_form(res.data);


            } catch (err) {
                this.error = 'Login failed';

                this.form_class = "";
                this.form_state = "error";
                this.current_notice = this.notice.default;
                this.current_explaination = this.notice.error;
                this.processing = false;
            }
            //}, 1500);
        },
        finish_form(data) {
            console.log('finishing form');
            this.current_notice = this.notice.success;
            this.processing = true;
            setTimeout(() => {
                this.current_notice = this.notice.success;
                this.advance_page(data);
            }, 1000);
        },
        advance_page(data) {
            console.log(data);
            console.log('advancing page');
            this.post_logged_in();
            setTimeout(() => {
                this.form_state = "hide";
                console.log('login form: updating state to sort');
                this.$emit('updateState', 'sort');
            }, 750);
        },
        post_logged_in() {
            let message = `Logged into the app`;
            let data = {
                type: 'open',
                message: message,
            };
            window.events.postAction(data);
        },
    }
}
</script>

<style lang="scss" scoped>
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

.notice__message {
    font-weight: $weight_bold;
}

.login__version {
    font-size: rem(11px);
    margin-top: rem(60px);
}

.login {
    position: fixed;
    inset: 0 0 0 0;
    height: 100vh;
    overflow: hidden;
    z-index: $z_top + 2;
    .login__wrap {
        background-color: var(--color-offwhite);
        height: 100%;
        width: 100%;
        transition: all 0.35s;
        transform: translateY(0);
    }
    &[data-state="hide"] {
        .login__wrap {
            pointer-events: none;
            transform: translateY(100%);
            border-top-left-radius: rem(24px);
            border-top-right-radius: rem(24px);
        }
        form {
            opacity: 0;
        }
    }
}
.eh {
    padding-block: calc(env(safe-area-inset-top) + 80px) rem(62px);
}
</style>